import { ButtonProps } from '../../atoms/Button';
import { TextProps } from '../../atoms/Text';


type ContactUsItemInternalProps = {
  title?: TextProps;
  message?: TextProps;
  button?: ButtonProps;
};

type ContactUsItemPropsValues = {
  '': ContactUsItemInternalProps;
};

const propValues: ContactUsItemPropsValues = {
  '': {
    title: {
      type: 'ContactBody',
      size: 'Large',
      style: 'SemiBold',
      colour: 'SubduedDark',
      align: 'Left',
    },
    message: {
      type: 'ContactBody',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Left',
    },
    button: {
      type: 'Text',
      style: 'ContainedGreen',
      size: 'Medium',
    },
  },
};

const getProps = (type: string): ContactUsItemInternalProps => {
  const values: ContactUsItemInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
